import { useEffect } from "react";

import * as Sentry from '@sentry/react';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
  } from "react-router-dom";

  
const sentryDSN = process.env.REACT_APP_SENTRY_DSN;
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const initializeSentry = () => {

  if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {

    if (!sentryDSN) {
      console.warn("Sentry DSN is missing.");
      return;
    }

    Sentry.init({
        dsn: `${sentryDSN}`,
        integrations: [
          // See docs for support of different versions of variation of react router
          // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
          Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          }),
          Sentry.replayIntegration(),
        ],
      
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        tracesSampleRate: 1.0,
      
        // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
        tracePropagationTargets: [/^\//, new RegExp(`^${process.env.REACT_APP_API_BASE_URL.replace(/\./g, '\\.')}/api`)],

      
        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });
  }
}

// Function to disable Sentry (this won't stop tracking immediately but prevents further logs)
export const disableSentry = () => {
  Sentry.close(); // Stops sending further events
  Sentry.init({ dsn: null }); // Effectively disables Sentry

};

// Check Klaro Consent before initializing Sentry
export const checkAndInitializeSentry = () => {
  try {
      const manager = window.klaro?.getManager();
      if (manager?.getConsent("sentry")) {
          initializeSentry();
      } 
  } catch (error) {
      //console.error("Error accessing Klaro manager for Sentry:", error);
  }
};

window.disableSentry = disableSentry;
